import React from "react";
import india from "../../../images/ind.png";
import { indianNumberFormat } from "../../../utils/handlers";
import { truncateText } from "../../../utils/handlers";

function VehicleBadge({ vehicle }) {
  return (
    <div className="flex flex-row justify-between items-center bg-[#f1f1f1] p-4 rounded-lg">
      <div style={{ flexBasis: "100%" }}>
        <div className="flex flex-row justify-between items-center">
          <div className="bg-[#262626] pl-2 pr-2 pt-[2px] pb-[2px] flex flex-row justify-center items-center rounded-sm">
            <img
              src={india}
              alt="india"
              className="w-[13px] h-[13px] mr-[10px]"
            />
            <p className="text-sm font-medium text-white">
              {vehicle?.vehicle_number || "---"}
            </p>
          </div>
          <h5 className="text-sm font-bold text-[#262626] capitalize text-right">
            {truncateText(vehicle?.model_name, 20)}
          </h5>
        </div>
        <div
          className="flex flex-row justify-between items-center"
          style={{ marginTop: "12px" }}
        >
          <div className="flex flex-col justify-start">
            <p className="text-xs font-medium text-[#848484] mb-[6px]">
              Current Value:
            </p>
            <h5 className="text-[#47b971] text-sm font-bold">
              &#8377;{indianNumberFormat(vehicle?.current_price)}
            </h5>
          </div>
          <div
            className="flex flex-col justify-start"
            style={{ textAlign: "end" }}
          >
            <p className="text-xs font-medium text-[#848484] mb-[6px]">
              Owner Name:
            </p>
            <h5 className="text-sm font-bold text-[#262626] capitalize">
              {truncateText(vehicle?.owner_name, 25) || "---"}
            </h5>
          </div>
        </div>
        <div
          className="flex flex-row justify-between items-center"
          style={{ marginTop: "12px" }}
        >
          <div className="flex flex-col justify-start">
            <p className="text-xs font-medium text-[#848484] mb-[6px]">
              Ex-Showroom Value
            </p>
            <h5 className="text-[#262626] text-sm font-bold">
              &#8377; {indianNumberFormat(vehicle?.ex_showroom_price) || "---"}
            </h5>
          </div>
          <div
            className="flex flex-col justify-start"
            style={{ textAlign: "end" }}
          >
            <p className="text-xs font-medium text-[#848484] mb-[6px]">
              Financier
            </p>
            <h5 className="text-[#262626] text-sm font-bold text-end">
              {vehicle?.hypotecation_details?.financier || "---"}
            </h5>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
}

export default VehicleBadge;
